module.exports = __webpack_public_path__ + "img/jingdong.4fcbf257.png";